import { render } from "./calendarioreservas.vue?vue&type=template&id=0d46a808&scoped=true"
import script from "./calendarioreservas.vue?vue&type=script&lang=js"
export * from "./calendarioreservas.vue?vue&type=script&lang=js"

import "./calendarioreservas.vue?vue&type=style&index=0&id=0d46a808&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d46a808"]])

export default __exports__